import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as UIC from '@dds-uicore/all';
import { CommonService } from 'src/app/shared/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})

export class TextEditorComponent implements OnInit {
  @Input() savedHtmlContent: any;
  htmlContentToSend: any;
  @Output() htmlContentToSaveBack = new EventEmitter<any>();
  @Output() htmlContentChangeEvent = new EventEmitter<any>();
  private getImages: Function;
  private uploadFilesAction: Function;
  form: UntypedFormGroup;
  preview: HTMLElement;
  loading: boolean = false;
  UploadedMedia: Array<{ saasUri: string, fileType: string }> = [];
  selection: any;
  percentage: number;
  blobSaasUrl:string;
  // videoLimit=environment.videoLimitMB;
  chunkSizeMB=environment.chunkSizeMB;
  range: any = null;
  hasClickedonEditor:boolean=true;
  pasteHtmlAtCaret: (html: any) => void;
  getLatestCursor: () => Range;
  validateInputs: (ContentTypeValue: any, txtFileValue: any, btn) => boolean;
  modalError:string=null;
  modalBlobError:string=null;
  constructor(private commonService: CommonService, private router: Router) { }
  ngOnInit(): void {
    /*...Rich Editor JS Code-Start...*/

    /* Define Vars-Start*/
    var editor = document.getElementsByClassName('editor')[0] as HTMLElement;
    var toolbar = editor.getElementsByClassName('toolbar')[0] as HTMLElement;
    var buttons = toolbar.querySelectorAll('.dds__btn');
    var contentArea = editor.getElementsByClassName('content-area')[0] as HTMLElement;
    var visualView = contentArea.getElementsByClassName('visual-view')[0] as HTMLElement;

    visualView.innerHTML = this.savedHtmlContent ?? "";
    this.htmlContentToSend = visualView;
    document.getElementById("visual-view")?.addEventListener(
      'input',
      this.emitContentToSave.bind(this)
    );
    document.getElementById("visual-view")?.addEventListener(
      'focusout',
      this.sendEvent.bind(this)
    );
    var htmlView = contentArea.getElementsByClassName('html-view')[0] as HTMLInputElement;
    // var overlay = document.getElementsByClassName('dds__overlay')[0] as HTMLElement;
    var pasteId = document.getElementById('paste') as HTMLElement;
    var selectOption = toolbar.querySelectorAll('select')[0] as HTMLElement;
    /* Define Vars-End*/

    /* Placeholder in Visual view-Start*/
    function clearPlaceHolder() {
      if (visualView.innerText.length == 0) {
        visualView.innerHTML = "";
      }
    }
    visualView.addEventListener('keyup click change input', clearPlaceHolder);
    /* Placeholder in Visual view-End*/

    /* Add active tag event-Start*/
    document.addEventListener('selectionchange', selectionChange);
    /* Add active tag event-End*/

    /* Add toolbar button actions-Start*/
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      button.addEventListener('click', function (e) {
        let action = this.dataset.action;

        switch (action) {
          case 'code':
            execCodeAction(this, editor);
            break;
          case 'createLink':
            InsertLink();
            break;
          // case 'insertImage':
          //      getImage();
          //      break;
          default:
            execDefaultAction(action);
        }

      });
    }
    /* Add toolbar button actions-End*/

    /* This function toggles between visual and html view-Start*/
    function execCodeAction(button, editor) {
      if (button.classList.contains('active')) {
        /* show visuell view*/
        visualView.innerHTML = htmlView.value;
        htmlView.style.display = 'none';
        visualView.style.display = 'block';
        button.classList.remove('active');
      } else {
        /* show html view*/
        htmlView.innerText = visualView.innerHTML;
        visualView.style.display = 'none';
        htmlView.style.display = 'block';
        button.classList.add('active');
      }
    }
    /* This function toggles between visual and html view-End*/

    /* add link action-Start*/
    function InsertLink() {
      let selection = saveSelection();
      let linkURL = prompt("Enter the Link (example: https://dell.com/)");
      restoreSelection(selection);
      if (window.getSelection().toString()) {
        let a = document.createElement('a');
        a.href = linkURL;
        a.target = '_blank';
        window.getSelection().getRangeAt(0).surroundContents(a);
      }
    }

    /* executes normal Action-Start*/
    function execDefaultAction(action) {
      document.execCommand(action, false);
    }
    /* executes normal Action-End*/

    this.getLatestCursor = () => {
      if (window.getSelection()) {
        try {
          let editorDiv= document.getElementById('parentEditor');
          let currentDiv= window.getSelection().anchorNode.parentElement;
          if(editorDiv.contains(currentDiv)){
            return window.getSelection().getRangeAt(0);
          }
        }
        catch (e) {
          return null;

        }
      }
      return null;
    }
    /* saves the current selection-Start*/
    function saveSelection() {
      if (window.getSelection) {
        const sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          let ranges = [];
          for (var i = 0, len = sel.rangeCount; i < len; ++i) {
            ranges.push(sel.getRangeAt(i));
          }
          return ranges;
        }
      } else if (document.getSelection() && document.getSelection()) {
        return document.getSelection();
      }
      return null;
    }
    /* saves the current selection-End*/

    /* loads a saved selection-Start*/
    function restoreSelection(savedSel) {
      if (savedSel) {
        if (window.getSelection) {
          const sel = window.getSelection();
          sel.removeAllRanges();
          for (var i = 0, len = savedSel.length; i < len; ++i) {
            sel.addRange(savedSel[i]);
          }
        } else if (document.getSelection() && savedSel.select) {
          savedSel.select();
        }
      }
    }
    /* loads a saved selection-End*/

    /* sets the current format buttons active/inactive-Start*/
    function selectionChange() {
      for (let i = 0; i < buttons.length; i++) {
        let button = buttons[i];
        button.classList.remove('active');
      }
       parentTagActive(window.getSelection().anchorNode.parentNode);
    }
    /* sets the current format buttons active/inactive-End*/

    /* ""-Start*/

function parentTagActive(elem) {

  if (elem.classList?.contains('visuell-view')) return false;
  let toolbarButton;
  // active by tag names
  let tagName = elem.tagName.toLowerCase();
  toolbarButton = toolbar.querySelectorAll(`.toolbar .dds__btn[data-tag-name="${tagName}"]`)[0];

  if (toolbarButton) {
      toolbarButton.classList.add('active');
  }

  // active by text-align

  let textAlign = elem.style.textAlign;
  toolbarButton = toolbar.querySelectorAll(`.toolbar .dds__btn[data-style="textAlign:${textAlign}"]`)[0];
  if (toolbarButton) {

      toolbarButton.classList.add('active');

  }

  return parentTagActive(elem.parentNode);

}
    /* ""-End*/

    /* Font Formatting Selects-Start*/
    document.getElementById('FontFamily').addEventListener('change', FormattingContentUsingSelect);
    document.getElementById('FontSize').addEventListener('change', FormattingContentUsingSelect);
    document.getElementById('Heading').addEventListener('change', FormattingContentUsingSelect);
    document.getElementById('FontColor').addEventListener('change', FormattingContentUsingSelect);
    document.getElementById('BackgroundColor').addEventListener('change', FormattingContentUsingSelect);

    function FormattingContentUsingSelect() {
      var action = this.dataset.action, aValueArgument = this.value, aShowDefaultUI = false;
      if (this.dataset.action == 'show-default-ui')
        aShowDefaultUI = this.dataset.action;
      document.execCommand(action, aShowDefaultUI, aValueArgument);
    }
    /* Font Formatting Selects-End*/

    /* Paste Functionality-Start*/
    /* Paste Functionality Ctrl+V -Start*/
    visualView.addEventListener('paste', function (e) {
      e.preventDefault();
      var text = '';
      if (e.clipboardData || e) {
        text = (e || e).clipboardData.getData('text/plain');
      } else if (e.clipboardData) {

        text = e.clipboardData.getData('Text');
      }
      if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, text);
      } else {
        document.execCommand('paste', false, text);
      }
    });
    /* Paste Functionality Ctrl+V -End*/
    /* Paste Functionality Button Press-Start*/
    pasteId.addEventListener('click', function (e) {
      navigator.clipboard.readText().then((text) => {
        if (document.queryCommandSupported('insertText')) {
          document.execCommand('insertText', false, text);
        } else {
          document.execCommand('paste', false, text);
        }
      });
    });
    /* Paste Functionality Button Press-End*/
    /* Paste Functionality-End*/

    /* Get Image-Start*/
    this.getImages = () => {
      var files: HTMLInputElement = <HTMLInputElement>document.querySelector("input[type=file]");
      var file = files.files[0];
      var reader = new FileReader();
      let dataURI;
      reader.addEventListener("load", function () {
        dataURI = reader.result;
        const div = document.createElement("div");
        div.innerText = " ";
        const img = document.createElement("img");
        img.src = dataURI;
        if (img.width == 0) {
          setTimeout(() => {
            if (img.width > 500) {
              img.style.width = '50%';
            }
            img.style.height = 'auto';
            div.append(img);
            document.execCommand('insertHTML', false, div.innerHTML);
          }, 3000);
        }
        else {
          if (img.width > 500) {
            img.style.width = '50%';
          }
          img.style.height = 'auto';
          div.append(img);
          document.execCommand('insertHTML', false, div.innerHTML);
        }
        //visuellView.appendChild(div);
      }, false);
      if (file) {
        reader.readAsDataURL(file);
      }
      files.value = null;
    }


    /* ""-End*/
    enableImageResizeInDiv('visual-view');
    function enableImageResizeInDiv(id) {
      if (!(/chrome/i.test(navigator.userAgent) && /google/i.test(window.navigator.vendor))) {
        return;
      }
      var editor = document.getElementById(id);
      var resizing = false;
      var currentImage;
      var createDOM = function (elementType, className, styles) {
        let ele = document.createElement(elementType);
        ele.className = className;
        setStyle(ele, styles);
        return ele;
      };
      var setStyle = function (ele, styles) {
        for (var key in styles) {
          ele.style[key] = styles[key];
        }
        return ele;
      };
      var removeResizeFrame = function () {
        document.querySelectorAll(".resize-frame,.resizer").forEach((item) => item.parentNode.removeChild(item));
      };
      var offset = function offset(el) {
        const rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
      };
      var clickImage = function (img) {
        removeResizeFrame();
        currentImage = img;
        const imgHeight = img.offsetHeight;
        const imgWidth = img.offsetWidth;
        const imgPosition = { top: img.offsetTop, left: img.offsetLeft };
        const editorScrollTop = editor.scrollTop;
        const editorScrollLeft = editor.scrollLeft;
        const top = imgPosition.top - editorScrollTop - 1;
        const left = imgPosition.left - editorScrollLeft - 1;



        editor.append(createDOM('span', 'resize-frame', {
          margin: '10px',
          position: 'absolute',
          top: (top + imgHeight - 10) + 'px',
          left: (left + imgWidth - 10) + 'px',
          border: 'solid 3px blue',
          width: '6px',
          height: '6px',
          cursor: 'se-resize',
          zIndex: 1
        }));



        editor.append(createDOM('span', 'resizer top-border', {
          position: 'absolute',
          top: (top) + 'px',
          left: (left) + 'px',
          border: 'dashed 1px grey',
          width: imgWidth + 'px',
          height: '0px'
        }));



        editor.append(createDOM('span', 'resizer left-border', {
          position: 'absolute',
          top: (top) + 'px',
          left: (left) + 'px',
          border: 'dashed 1px grey',
          width: '0px',
          height: imgHeight + 'px'
        }));



        editor.append(createDOM('span', 'resizer right-border', {
          position: 'absolute',
          top: (top) + 'px',
          left: (left + imgWidth) + 'px',
          border: 'dashed 1px grey',
          width: '0px',
          height: imgHeight + 'px'
        }));



        editor.append(createDOM('span', 'resizer bottom-border', {
          position: 'absolute',
          top: (top + imgHeight) + 'px',
          left: (left) + 'px',
          border: 'dashed 1px grey',
          width: imgWidth + 'px',
          height: '0px'
        }));



        var resizeFrame = document.querySelector('.resize-frame') as HTMLElement;
        resizeFrame.onmousedown = () => {
          resizing = true;
          return false;
        };



        editor.onmouseup = () => {
          if (resizing) {
            let topborder = document.querySelector('.top-border') as HTMLElement;
            currentImage.style.width = topborder.offsetWidth + 'px';
            let leftborder = document.querySelector('.left-border') as HTMLElement;
            currentImage.style.height = leftborder.offsetHeight + 'px';
            refresh();
            currentImage.click();
            resizing = false;
          }
        };



        editor.onmousemove = (e) => {
          if (currentImage && resizing) {
            let height = e.pageY - offset(currentImage).top;
            let width = e.pageX - offset(currentImage).left;
            height = height < 1 ? 1 : height;
            width = width < 1 ? 1 : width;
            const top = imgPosition.top - editorScrollTop - 1;
            const left = imgPosition.left - editorScrollLeft - 1;
            setStyle(document.querySelector('.resize-frame'), {
              top: (top + height - 10) + 'px',
              left: (left + width - 10) + "px"
            });



            setStyle(document.querySelector('.top-border'), { width: width + "px" });
            setStyle(document.querySelector('.left-border'), { height: height + "px" });
            setStyle(document.querySelector('.right-border'), {
              left: (left + width) + 'px',
              height: height + "px"
            });
            setStyle(document.querySelector('.bottom-border'), {
              top: (top + height) + 'px',
              width: width + "px"
            });
          }
          return false;
        };
      };
      var bindClickListener = function () {
        editor.querySelectorAll('img').forEach((img, i) => {
          img.onclick = (e) => {
            if (e.target === img) {
              clickImage(img);
            }
          };
        });
      };
      var refresh = function () {
        bindClickListener();
        removeResizeFrame();
        if (!currentImage) {
          return;
        }
        var img = currentImage;
        var imgHeight = img.offsetHeight;
        var imgWidth = img.offsetWidth;
        var imgPosition = { top: img.offsetTop, left: img.offsetLeft };
        var editorScrollTop = editor.scrollTop;
        var editorScrollLeft = editor.scrollLeft;
        const top = imgPosition.top - editorScrollTop - 1;
        const left = imgPosition.left - editorScrollLeft - 1;



        editor.append(createDOM('span', 'resize-frame', {
          position: 'absolute',
          top: (top + imgHeight) + 'px',
          left: (left + imgWidth) + 'px',
          border: 'solid 2px red',
          width: '6px',
          height: '6px',
          cursor: 'se-resize',
          zIndex: 1
        }));



        editor.append(createDOM('span', 'resizer', {
          position: 'absolute',
          top: (top) + 'px',
          left: (left) + 'px',
          border: 'dashed 1px grey',
          width: imgWidth + 'px',
          height: '0px'
        }));



        editor.append(createDOM('span', 'resizer', {
          position: 'absolute',
          top: (top) + 'px',
          left: (left + imgWidth) + 'px',
          border: 'dashed 1px grey',
          width: '0px',
          height: imgHeight + 'px'
        }));



        editor.append(createDOM('span', 'resizer', {
          position: 'absolute',
          top: (top + imgHeight) + 'px',
          left: (left) + 'px',
          border: 'dashed 1px grey',
          width: imgWidth + 'px',
          height: '0px'
        }));
      };
      var reset = function () {
        if (currentImage != null) {
          currentImage = null;
          resizing = false;
          removeResizeFrame();
        }
        bindClickListener();
      };
      editor.addEventListener('scroll', function () {
        reset();
      }, false);
      editor.addEventListener('mouseup', function (e) {
        if (!resizing) {
          const x = (e.x) ? e.x : e.clientX;
          const y = (e.y) ? e.y : e.clientY;
          let mouseUpElement = document.elementFromPoint(x, y);
          if (mouseUpElement) {
            let matchingElement = null;
            if (mouseUpElement.tagName === 'IMG') {
              matchingElement = mouseUpElement;
            }
            if (!matchingElement) {
              reset();
            } else {
              clickImage(matchingElement);
            }
          }
        }
      });
    }

    function GenerateMediaTags(ContentTypeValue, txtFileValue, srcType = 'video/mp4') {

      let div,br;
      br = document.createElement("br");
      switch (ContentTypeValue) {
        case 'youtube':
          //txtFileValue = "https://www.youtube.com/watch?v=YKLX3QbKBg0";
          let iframe = document.createElement("iframe");
          iframe.src = txtFileValue.replace('/watch?v=', '/embed/');
          iframe.width = "560";
          iframe.height = "315";
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
          div = document.createElement("div");
          div.innerHTML = "&nbsp;";
          div.append(iframe);
          div.append(br);
          break;
        case 'image':
          //txtFileValue = "https://www.fiberopticshare.com/wp-content/uploads/2019/05/rack-network-server.jpg";
          let img = document.createElement("img");
          img.src = txtFileValue;
          // if (img.width > 500) {
          //   img.style.width = '50%';
          // }
          // img.style.height = 'auto';
          img.alt="This URL cannot be embedded"
          img.width = 200;
          img.height = 200;
          div = document.createElement("div");
          div.innerHTML = "&nbsp;";
          div.append(img);
          div.append(br);
          break;
        case 'other':
          //txtFileValue = "https://lkemu.blob.core.windows.net/lkemu-video/bGtlbXUtdmlkZW8uNTY5Wm9QLzdlSmkwcysyUFlKV0ZaQT09";
          let video = document.createElement("video");
          video.width = 450;
          video.height = 300;
          video.setAttribute("controls", "controls");
          // video.controls = "controls";
          video.preload = "metadata";
          video.poster = "";
          // video.setAttribute("data-setup", '{"techOrder": ["azureHtml5JS", "flashSS", "html5FairPlayHLS","silverlightSS", "html5"], "nativeControlsForTouch": false}');
          let source = document.createElement("source");
          //source.src = "https://lkemu.blob.core.windows.net/lkemu-video/bGtlbXUtdmlkZW8uNTY5Wm9QLzdlSmkwcysyUFlKV0ZaQT09";
          //source.src = "https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4";
          source.src = txtFileValue;
          source.type = srcType;
          video.append(source);
          div = document.createElement("div");
          div.innerHTML = "&nbsp;";
          div.append(video);
          div.append(br);
          break;
      }
      return div.innerHTML;
    }

    this.pasteHtmlAtCaret = (html) => {
      var range;
      if (this.range) {
        range = this.range;
        range.deleteContents();
        // Range.createContextualFragment() would be useful here but is
        // non-standard and not supported in all browsers (IE9, for one)
        var el = document.createElement("div");
        el.innerHTML = html;
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          // sel.removeAllRanges();
          // sel.addRange(range);
        }
      }

    }
    function isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    }

    function isValidBase64(str) {
      let header = str.split(',')[0]; //data:image/png;base64
      let base64 = str.split(',')[1]; //actual base64 part
      try {
        window.atob(base64);
      } catch (e) {
        return false;
      }
      return true;
    }

    this.validateInputs = (ContentTypeValue, txtFileValue, btn) => {
      //CONDITIONAL VALIDATIONS AS REQUIRED ARE PLACED HERE
      if ((btn == 'btnInsertHTML' || btn == 'btnPreview')) {
        if (ContentTypeValue === 'youtube'){
          if(!isValidHttpUrl(txtFileValue)){
            this.modalError="Please enter a valid URL.";
            if(this.preview){this.preview.innerHTML = null};
            return false;
          }
          else if (txtFileValue.includes('youtu.be')) {
            this.modalError="Shortened URLs like 'youtu.be' are not allowed.";
            if(this.preview){this.preview.innerHTML = null};
            return false;
          }
          else if (!txtFileValue.includes('youtube')) {
            this.modalError="Only youtube links are allowed.";
            if(this.preview){this.preview.innerHTML = null};
            return false;
          }
        }
        else{ //For image and Videos(other type)
            if (!(isValidHttpUrl(txtFileValue) || isValidBase64(txtFileValue))) { //Allow both Valid URLS and Valid base64 URLS, else restrict
            this.modalError="Please enter a valid URL.";
            if(this.preview){this.preview.innerHTML = null};
            return false;
          }
        }
      }
      this.modalError=null;//Remove any error messages upon successful Validation
      this.modalBlobError=null;
      return true;
    }
    /* Upload File action-Start*/
    this.uploadFilesAction = (ContentTypeValue, txtFileValue, btn) => {
      if(this.validateInputs(ContentTypeValue, txtFileValue,btn)){
        if (btn == 'btnPreview') {
          this.preview = document.getElementById('PreviewEmbededFile') as HTMLElement;
          this.preview.innerHTML =GenerateMediaTags(ContentTypeValue, txtFileValue);
          return;
        }
        if (btn == 'btnInsertHTML') {
          let mediadiv = GenerateMediaTags(ContentTypeValue, txtFileValue);
          this.pasteHtmlAtCaret(mediadiv);
        }
        else if (btn == 'btnInsertBlob') {
          for (let i = 0; i < this.UploadedMedia.length; i++) {
            let ContentType = this.UploadedMedia[i].fileType.includes('image') ? 'image' : 'other';
            let mediadiv = GenerateMediaTags(ContentType, this.UploadedMedia[i].saasUri, this.UploadedMedia[i].fileType);
            this.pasteHtmlAtCaret(mediadiv);
          }
        }
        //Close Modal
        let closeAction = document.getElementById('closeButton') as HTMLElement;
        closeAction.click();
      }
    }
    /* Upload File action-End*/


    //dds modal
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__modal\"]"), function (element) {
      let modal = new UIC.Modal(element, { backdrop: 'static' });
      // modal.show(); //It is required when modal needs to be open by default
    });

    //dds nav
    [].forEach.call(document.querySelectorAll('[data-toggle="dds__tab"]'), function (element) {
      new UIC.Tab(element);
    });
    //dds upload
    [].forEach.call(document.querySelectorAll("[ id=\"ModalUploadInput\"]"), function (element) {
      new UIC.FileUpload(element, {
      });
    });


    //DDS Modal Form
    this.form = new UntypedFormGroup({
      'ddlContentType': new UntypedFormControl('youtube', Validators.required),
      'txtFileUrl': new UntypedFormControl(null, Validators.required)
    })
    this.form.valueChanges.subscribe(val => { //DynamicError
      debugger
      if (val) {
         this.validateInputs(val.ddlContentType,val.txtFileUrl,'btnInsertHTML')
      }
  });
  }

   emitContentToSave() {

    if ((this.htmlContentToSend.innerText)?.trim() || this.htmlContentToSend.innerHTML.includes('<img') || this.htmlContentToSend.innerHTML.includes('<video'))
      this.htmlContentToSaveBack.emit(this.htmlContentToSend.innerHTML);
    else
      this.htmlContentToSaveBack.emit((this.htmlContentToSend.innerText)?.trim());


  }

  getImage() {
    this.getImages();
  }
  sendEvent(data) {
    this.htmlContentChangeEvent.emit('data');
  }
  transmitContentToSave(data: string) {
    this.htmlContentToSend.innerHTML = data
  }
  FileUpload(btn) {
    this.uploadFilesAction(this.form.get('ddlContentType').value, this.form.get('txtFileUrl').value, btn);
  }
  Initialize() {

    try{
      this.range = this.getLatestCursor();
      if (this.range) {
        document.getElementById("contentPopup").style.display="block";
        let loadingModal = new UIC.Modal(document.getElementById("modalbtn"), { backdrop: 'static' } );
        loadingModal.show();
      }
      else {
        //forcibly hiding the modal if it opens in some case
        document.getElementById("contentPopup").style.display="none";
        this.commonService.setNotification("Please click on the editor to insert the file/media", "Information");
        return;
        // let loadingModal = new UIC.Modal(document.getElementById("modalbtn"), { backdrop: 'static' } );
        // loadingModal.hide();
      }
    }
    catch(e){
      //forcibly hiding the modal if it opens in some case
      document.getElementById("contentPopup").style.display="none";
      this.commonService.setNotification("Please click on the editor to insert the file/media", "Information");
      return;
      // let loadingModal = new UIC.Modal(document.getElementById("modalbtn"), { backdrop: 'static' } );
      // loadingModal.hide();
    }

  }
  closeModal() {
    let uploadDiv =  document.getElementById('UploadFile').getElementsByClassName('dds__form-upload-target')[0] as HTMLElement;
    uploadDiv.classList.add('dds__d-none'); //Clear File Name on Modal Close
    if (this.preview) {
      this.preview.innerHTML = null;
    }
    this.form.setValue({
      ddlContentType: "youtube",
      txtFileUrl: ""
    });
    this.modalBlobError=null;
    this.modalError=null;
  }
  onDocPicked(event: Event) {
    if (event) {
      this.modalBlobError=null;//Reinitalize error msg
      this.UploadedMedia = [];
      let extensions = ['image/jpeg', 'image/jpg', 'image/png', 'video/ogg', 'video/mp4', 'video/webm', 'video/avi']; //This extra check is required since DDS simply gives a warning but do not restrict the users from uploading restricted extensions
      const inputElement = event.target as HTMLInputElement
      let uploadDiv =  document.getElementById('UploadFile').getElementsByClassName('dds__form-upload-target')[0] as HTMLElement;
      let loopFile = (fileIndex: number) => {
        const file = inputElement.files[fileIndex];
        const reader = new FileReader();
        this.blobSaasUrl="";
        let extension=file.type.substring(file.type.lastIndexOf('/') + 1);
        let fileReference=Date.now() + '' +  Math.random();
        const chunkSize = this.chunkSizeMB*1048576 ;
        let chunkIndex = 0;
        let totalChunks=Math.ceil(file.size / chunkSize);
        this.percentage = Math.trunc(chunkIndex / totalChunks * 100);
        // if (extensions.includes(file.type) && file.size < this.videoLimit* 1048576)  {
        if (extensions.includes(file.type))  {
          reader.onload =  () => {
            let loop = (offset: number) => {

              chunkIndex++;
              const chunk = file.slice(offset, offset + chunkSize);
              this.loading = true;
              this.commonService.sendChunk(chunk, chunkIndex, totalChunks, fileReference, extension, file.type).subscribe(
                (res) => {
                  if(res.Status=="Failure"){
                    this.modalBlobError="Something went wrong! Please try again in some time.";
                    this.loading=false;
                    fileIndex++;
                    if(fileIndex < inputElement.files.length)
                      loopFile(fileIndex);
                    return;
                  }
                  this.percentage = Math.trunc(chunkIndex / totalChunks * 100);
                  if (chunkIndex==totalChunks){

                    this.loading = false;
                    this.blobSaasUrl=res.data;
                    let media ={
                      saasUri:this.blobSaasUrl,
                      fileType:file.type,
                    }
                    this.UploadedMedia.push(media);
                    //close modal and trigger insert
                    this.uploadFilesAction(this.form.get('ddlContentType').value, this.form.get('txtFileUrl').value, 'btnInsertBlob');
                    uploadDiv.classList.remove('dds__d-none'); //Show Uploaded File Name
                    fileIndex++;
                    if(fileIndex < inputElement.files.length)
                      loopFile(fileIndex)
                  }
                  offset += chunkSize;
                  if (offset < file.size) {
                    loop(offset)
                  }
                })
            }
            loop(0);

          }
        }

        else {

          uploadDiv.classList.add('dds__d-none'); //Hide File Name
          fileIndex++;
          if(fileIndex < inputElement.files.length)
            loopFile(fileIndex);
          // this.commonService.setNotification("The specified file cannot be uploaded. Files with following extensions - 'jpeg', 'jpg', 'png', 'ogg', 'mp4', 'webm', 'avi'  smaller than "+this.videoLimit+"MB are allowed.", "Error");
          this.modalBlobError="The specified file cannot be uploaded. Files with following extensions - 'jpeg', 'jpg', 'png', 'ogg', 'mp4', 'webm', 'avi' are allowed.";
        }
        reader.readAsDataURL(file);
      }
      loopFile(0)
    }
  }


}

